import { useMutation, useQuery } from './urqlHooks';

const TRIGGER_PASCALE_BOT = `
mutation TriggerPascaleBot($input: TriggerPascaleBotInput) {
  triggerPascaleBot(input: $input) {
    totalDocuments
    processedBatches
    message
    startedAt
  }
}
`;

export const TriggerPascaleBot = () => {
  const [result, executeMutation] = useMutation(TRIGGER_PASCALE_BOT);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const GENERATE_ACCOUNTING_RECONSTRUCTION = `
mutation GenerateAccountingReconstruction($companyId: String!) {
  generateAccountingReconstruction(companyId: $companyId) {
    totalDocuments
    processedBatches
    message
    startedAt
  }
}
`;

export const GenerateAccountingReconstruction = () => {
  const [result, executeMutation] = useMutation(GENERATE_ACCOUNTING_RECONSTRUCTION);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const TRIGGER_ACCOUNTING_RECONSTRUCTION_SII_IMPORT = `
mutation TriggerAccountingReconstructionSiiImport($companyId: String!, $force: Boolean) {
  triggerAccountingReconstructionSiiImport(companyId: $companyId, force: $force) {
    totalDocuments
    processedBatches
    message
    startedAt
    accountingReconstructionStatus
    importAlreadyInProgress
  }
}
`;

export const TriggerAccountingReconstructionSiiImport = () => {
  const [result, executeMutation] = useMutation(TRIGGER_ACCOUNTING_RECONSTRUCTION_SII_IMPORT);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const GENERATE_RECONSTRUCTION_REPORT = `
mutation GenerateReconstructionReport($companyId: String!) {
  generateReconstructionReport(companyId: $companyId) {
    url
    fileName
  }
}
`;

export const GenerateReconstructionReport = () => {
  const [result, executeMutation] = useMutation(GENERATE_RECONSTRUCTION_REPORT);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const RECONSTRUCTION_BALANCE_ALERTS = `
query ReconstructionBalanceAlerts($companyId: String!) {
  reconstructionBalanceAlerts(companyId: $companyId) {
    hasProperties
    propertyCount
    properties
    hasDj1894Entry
    dj1894EntryId
    dj1894StringDate
  }
}
`;

export const GetReconstructionBalanceAlerts = ({ companyId, pause = false } = {}) => {
  const [result, reexecuteQuery] = useQuery({
    query: RECONSTRUCTION_BALANCE_ALERTS,
    variables: { companyId: companyId || '' },
    pause: pause || !companyId,
    requestPolicy: 'cache-and-network',
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

